import './index.css';

import { ContentfulClient, ContentfulProvider } from 'react-contentful';
import { NetZeroContainer, OptInContainer } from './containers';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import AccountDeletedContainer from './containers/AccountDeletedContainer';
import Amplify from 'aws-amplify';
import App from './App';
import React from 'react';
import TagManager from 'react-gtm-module';
import { YearSummaryContainer } from './containers';
import awsconfig from './config/aws-exports.js';
import contentfulConfig from './config/contentful';
import { createRoot } from 'react-dom/client';
import gtmConfig from './config/gtm';

const root = createRoot(document.getElementById('root'));

const contentfulClient = new ContentfulClient(contentfulConfig);

Amplify.configure(awsconfig);

TagManager.initialize({ gtmId: gtmConfig.id });

root.render(
  <React.StrictMode>
    <ContentfulProvider client={contentfulClient} locale="en-GB">
      <Router>
        <Routes>
          <Route path="/net-zero/*" element={<NetZeroContainer />} />
          <Route path="/year-summary" element={<YearSummaryContainer />} />
          <Route path="/opt-in" element={<OptInContainer />} />
          <Route
            path="/account-deleted"
            element={<AccountDeletedContainer />}
          />
          <Route path="*" element={<App />} />
        </Routes>
      </Router>
    </ContentfulProvider>
  </React.StrictMode>,
);
